import dynamic from 'next/dynamic';
import { BlockRenderer } from '../Fields/BlockRenderer';
import { resolveFields } from '../Fields';
import { Post, HeroProps } from '../../types';
import TeaserHeroFull from '../TeaserHeroFull';
import ArticleContainer from '../ArticleContainer';
import { useBlog } from '../../lib/hooks.context';

const AssociationSearch = dynamic(() => import('../AssociationSearch'));

const FrontPageHero = ({ campaign, buttons, ...hero }: HeroProps) => {
  const blog = useBlog(false);

  if (campaign && buttons) {
    return <TeaserHeroFull {...hero} buttons={buttons} />;
  }

  if (buttons || blog) {
    return <TeaserHeroFull {...hero} buttons={buttons} />;
  }

  return (
    <TeaserHeroFull {...hero}>
      <AssociationSearch />
    </TeaserHeroFull>
  );
};

const FrontPage = ({ fields }: Post) => {
  const [hero, contentFields] = resolveFields(fields);

  return (
    <ArticleContainer>
      {hero && <FrontPageHero {...hero} />}
      <BlockRenderer blocks={contentFields} />
    </ArticleContainer>
  );
};

export default FrontPage;
